export default "__VITE_ASSET__Brbr0hdK__"